export default "__VITE_ASSET__JWLMra2m__"